import React from 'react';

export const Youtube = ({ className }) => {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M31.7379 9.80949C33.0229 10.1555 34.0361 11.1686 34.3821 12.4536C35.0246 14.8012 34.9999 19.6941 34.9999 19.6941C34.9999 19.6941 34.9999 24.5623 34.3821 26.9099C34.0361 28.1949 33.0229 29.2081 31.7379 29.5541C29.3903 30.1718 19.9999 30.1718 19.9999 30.1718C19.9999 30.1718 10.6342 30.1718 8.26193 29.5293C6.97693 29.1834 5.96375 28.1702 5.61779 26.8852C5 24.5623 5 19.6694 5 19.6694C5 19.6694 5 14.8012 5.61779 12.4536C5.96375 11.1686 7.00164 10.1307 8.26193 9.78478C10.6095 9.16699 19.9999 9.16699 19.9999 9.16699C19.9999 9.16699 29.3903 9.16699 31.7379 9.80949ZM24.8187 19.4978L17.0098 23.9953V15.0003L24.8187 19.4978Z" fill="white"/>
</svg>


  );
};
